import { useState } from 'react';
import { dateMonthYearDateFormat } from '../../../../constants';
import moment from 'moment';
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { NoRecordFound } from '../../../../shared_elements';
import { claimObj, ClaimList, ClaimCRU } from '.';
import { PageLoader, DeletePopUp } from '../../../../shared_elements';
import { deleteClaimApi } from '../apiService';
import { checkApiStatus } from '../../../../utils';
import { globalDeleteService } from '../../../../utils/globalApiServices';
import { Paper, Button, Tooltip, Typography, Grid, Box, Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';
import { Restore as RestoreIcon, AttachFile as AttachFileIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { ShowAttachments } from '../../../../shared_elements/components';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { PermissionWrapper } from '../../../../wrappers';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import { trackActivity } from '../../../../utils/mixpanel';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import { useSelector } from 'react-redux';
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import NumericLabel from 'react-pretty-numbers';
import AuditPopover from '../../../../shared_elements/components/popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TruncatedText = ({ text, limit = 15 }) => {
  if (!text) return '--';
  const isLong = text.length > limit;
  const truncated = isLong ? text.slice(0, limit) + "..." : text;
  const content = (
    <Typography sx={{ fontSize: 13, fontWeight: 400, fontFamily: "Roboto-Regular", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "150px", cursor: isLong ? "pointer" : "default" }}>
      {truncated}
    </Typography>
  );
  return isLong ? (
    <Tooltip title={text} arrow placement="top">
      {content}
    </Tooltip>
  ) : (
    content
  );
};



const ClaimHeader = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header"> Action(s) </TableCell>
                <TableCell sx={{ minWidth: '110px' }}>Claim No. </TableCell>
                <TableCell sx={{ minWidth: '110px' }}>Amount </TableCell>
                <TableCell sx={{ minWidth: '120px' }}>Status </TableCell>
                <TableCell sx={{ minWidth: '140px' }}>Approver </TableCell>
                <TableCell sx={{ minWidth: '110px' }}>Closure Date </TableCell>
                <TableCell sx={{ minWidth: '140px' }}>Primary Contact  </TableCell>
                <TableCell sx={{ minWidth: '180px' }}>Remarks </TableCell>
            </TableRow>
        </TableHead>
    )
}

function InsuranceList({ uploadedFileData,viewFileStatus,item,onAddVariability,viewRevisonHistory, index, onViewFn, onEditFn, onDeleteFn, onOpenAttachments, onOpenClaimAttachments, getResponseBack }) {
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
     const {fileUploadDetails} = useSelector((state) => state.leases);
    const [claimCRU, setClaimCRU] = useState({ modal: false, data: null, mode: '' })
    const [attachments, setAttachments] = useState({ modal: false, data: null, type: '', mode:'' })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [deleteClaim, setDeleteClaim] = useState({ modal: false, data: null, })
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const[uploadFileProgressData, setUploadFileProgressData]=useState({})
    const [slug,setSlug]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const onDeletAttachment = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (claimCRU?.modal) {
            setClaimCRU({
                ...claimCRU,
                data: {
                    ...claimCRU.data,
                    attachments: claimCRU.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getResponseBack();
    }

    const deleteClaimFn = () => {
        setLoading(true);
        globalDeleteService(deleteClaimApi({ ...params, insuranceSlug: item?.slug }), { ids: [deleteClaim?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Claim`, success_msg: response?.data?.message, item_id: deleteClaim?.data, response: response?.data })
                    setLoading(false);
                    setDeleteClaim({ modal: false, data: null });
                    getResponseBack();
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Claim`, error_msg: response?.data?.message, item_id: deleteClaim?.data, response: response?.data })
                }
            })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Insurance Listing`, page_type: page_type, })
    }


    const handleUpload = async (slug, mode) => {
      setSlug({slug:slug})
      await fileUpload({
      attachments: fileUploadDetails.attachments,
      module_name: "insurance_claim",
      slug: slug,
      query: { record_action_type: mode },
    //   onStart: () => setLoading(true),
      onComplete: () => setLoading(false),
      onProgress: ({ progressRefs, attachments, response}) => {
      setUploadFileProgressData({ progressRefs, attachments ,response});
     },
     onSuccess: (success_msg) => {
      enqueueSnackbar(success_msg, {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" }
      });
       getResponseBack("", { per_page: 20 });
     },
     onError: (err) => {
      enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "right" }
      });
     }
     });
      setSlug({})
    };

    return (
        <section style={{ border: '1px solid #D7D7D7', marginBottom: '20px' }}>
            <Paper key={index} elevation={0} square sx={{ padding: '5px', background: '#EAEAEA' }}>
                <Grid container spacing={1.5} alignItems="flex-start" wrap='nowrap'>
                    <Grid item sx={{position:'sticky',left:0, zIndex:2}} minWidth={200}>
                        <Typography className='insurance-tab-typo' sx={{paddingLeft: '7px'}}>Action(s)</Typography>
                        <Box className="table-icon-container" sx={{padding: '2px'}}>
                            <AuditPopover item={item}>
                                <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                            </AuditPopover>
                            <Tooltip title="Revision History"><RestoreIcon className='revision-history' onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} fontSize="small" color="primary" /></Tooltip>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['R'] }}>
                                <Tooltip title="View"><VisibilityIcon sx={{ cursor: 'pointer' }} onClick={() => { onViewFn(); handleItemClicked('ViewIcon') }} fontSize='small' color='primary' /></Tooltip>
                            </PermissionWrapper>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['U'] }}>
                                <Tooltip title="Edit"><EditIcon sx={{ cursor: 'pointer' }} onClick={() => { onEditFn(); handleItemClicked('EditIcon') }} fontSize='small' color='primary' /></Tooltip>
                            </PermissionWrapper>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['U'] }}>
                                <Tooltip title="View Variability Schedule"><OpenInNewIcon sx={{ cursor: 'pointer' }} onClick={() => { onAddVariability(); handleItemClicked('VariablityIcon') }} fontSize='small' color='primary' /></Tooltip>  </PermissionWrapper>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['D'] }}>
                                <Tooltip title="Delete"><DeleteIcon sx={{ cursor: 'pointer' }} onClick={() => { onDeleteFn(); handleItemClicked('DeleteIcon') }} fontSize='small' color='error' /></Tooltip>
                            </PermissionWrapper>
                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['R'] }}>
                                {
                                    item?.attachments?.length > 0 && (
                                        <Tooltip title="Attached File(s)">
                                            <Box className="attachment-container">
                                                <AttachFileIcon fontSize="small" color="primary" onClick={() => { onOpenAttachments(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                                                <Box className="attachment-count"> ({item?.attachments?.length}) </Box>
                                            </Box>
                                        </Tooltip>
                                    )
                                }
                            </PermissionWrapper>
                            {(slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} />}
                        </Box>
                    </Grid>
                    <Grid item sx={{ flex: 1, minWidth: 0, overflowX: 'auto', scrollbarWidth: 'thin' }}>
                        <Grid container spacing={2} width='max-content'>
                            <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>Insurance Type</Typography>
                                <TruncatedText text={item?.insurance_type?.name} limit={15} />
                            </Grid>
                            <Grid item minWidth={150}>
                                <Typography className='insurance-tab-typo'>Insurance No.</Typography>
                                <TruncatedText text={item?.insurance_number} limit={15} />
                            </Grid>
                            <Grid item minWidth={150}>
                                <Typography className='insurance-tab-typo'>Insurer</Typography>
                                <TruncatedText text={item?.insurer} limit={15} />
                            </Grid>
                            <Grid item minWidth={150}>
                                <Typography className='insurance-tab-typo'>Insuree</Typography>
                                <TruncatedText text={item?.insuree} limit={15} />
                            </Grid>
                            <Grid item minWidth={150}>
                                <Typography className='insurance-tab-typo'>Policy Start Date</Typography>
                                <Typography className="insurance-tab-data">
                                    {item?.policy_start_date ? moment(item?.policy_start_date).format(dateMonthYearDateFormat) : '--'}
                                </Typography>
                            </Grid>
                            <Grid item minWidth={150}>
                                <Typography className='insurance-tab-typo'>Policy End Date</Typography>
                                <Typography className="insurance-tab-data">
                                    {item?.policy_end_date ? moment(item?.policy_end_date).format(dateMonthYearDateFormat) : '--'}
                                </Typography>
                            </Grid>
                            <Grid item minWidth={150}>
                                <Typography className='insurance-tab-typo'>Insurance Amount</Typography>
                                {/* <Typography sx={{ fontSize: 13, fontWeight: 400, wordBreak: 'break-word' }}>
                                    {item?.insurance_amount ? `${item?.currency?.code} ${item?.currency?.symbol}${item?.insurance_amount}` : '--'}
                                </Typography> */}
                                <Typography className="insurance-tab-data">
                                    {item?.insurance_amount ? (
                                        <NumericLabel
                                            params={{
                                                locales: 'en-GB',
                                                currency: true,
                                                precision: 2,
                                                currencyIndicator: item?.currency?.code || item?.currency?.symbol?.code || '',
                                                commafy: true,
                                                justification: "L",
                                            }}
                                        >{Number(item?.insurance_amount)}</NumericLabel>
                                    ) : (
                                        "--"
                                    )}
                                </Typography>
                            </Grid>
                             <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>Policy Renewal Date</Typography>
                                <TruncatedText text={item?.policy_renewal_date} limit={15} />
                            </Grid>
                             <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>Re-Insurer</Typography>
                                <TruncatedText text={item?.re_insurer} limit={15} />
                            </Grid>
                             <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>Geo-Limit</Typography>
                                <TruncatedText text={item?.geo_limit} limit={15} />
                            </Grid>
                             <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>Deductible Amount</Typography>
                                <Typography className="insurance-tab-data">
                                    {item?.deductible_amount ? (
                                        <NumericLabel
                                            params={{
                                                locales: 'en-GB',
                                                currency: true,
                                                precision: 2,
                                                currencyIndicator: item?.currency?.code || item?.currency?.symbol?.code || '',
                                                commafy: true,
                                                justification: "L",
                                            }}
                                        >{Number(item?.deductible_amount)}</NumericLabel>
                                    ) : (
                                        "--"
                                    )}
                                </Typography>                                
                            </Grid>
                             <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>Effective Date</Typography>
                                <TruncatedText text={item?.effective_date} limit={15} />
                            </Grid>
                             <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>Primary Contact</Typography>
                                <TruncatedText text={item?.primary_contact} limit={15} />
                            </Grid>
                             <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>Lease Stipulated Requirement</Typography>
                                <TruncatedText text={item?.lease_stipulated_requirement} limit={25} />
                            </Grid>
                             <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>Aggregate</Typography>
                                <TruncatedText text={item?.aggregate} limit={15} />
                            </Grid>
                             <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>War</Typography>
                                <TruncatedText text={item?.war} limit={15} />
                            </Grid>
                             <Grid item minWidth={150} >
                                <Typography className='insurance-tab-typo'>Government Indemnity</Typography>
                                <TruncatedText text={item?.government_indemnity} limit={20} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
            <Grid container>
                {item?.insurance_claims?.length > 0 || !item?.insurance_amount ? null : <Grid size={{ xs: 12, md: 12 }} sx={{ textAlign: 'right', padding: '6px 10px' }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "insurance", operationType: ['C'] }}>
                        <Button startIcon={<AddOutlinedIcon />} onClick={() => {setClaimCRU({ modal: true, data: claimObj, mode: 'add', });handleItemClicked('Add Claim Button')}} variant="outlined" color="primary" size='small' className='btn-primary action-btn-start-icon'> Add Claim </Button>
                    </PermissionWrapper>
                </Grid>}
                <Grid size={{ xs: 12, md: 12 }} >
                    <div style={{ maxHeight: `${window.innerHeight - 265}px`, overflow: 'auto' }}>
                        <Table className='mui-table-format' stickyHeader>
                            <ClaimHeader />
                            <TableBody>
                                {item?.insurance_claims?.length > 0 && item?.insurance_claims?.map((claim, index) =>{
                                     const uploadedFileData = getApiResponse("insurance", claim?.slug);

                                   return (
                                        <ClaimList
                                             slug={slug?.slug}
                                              uploadedFileData={uploadedFileData }
                                              uploadFileProgressData={uploadFileProgressData}
                                              viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                              index={index}
                                              key={index}
                                              item={claim}
                                              currency={item?.currency}
                                              extraData={item}
                                              getResponseBack={getResponseBack}
                                              onDeleteFn={() => setDeleteClaim({ modal: true, data: item })}
                                              viewRevisonHistory={() => setRevisionHistory({ modal: true, data: claim, mode: 'view' })}
                                              onOpenAttachments={() => setAttachments({ modal: true, data: claim, })}
                                              onViewFn={() => setClaimCRU({ modal: true, data: claim, mode: 'view', })}
                                              onEditFn={() => setClaimCRU({ modal: true, data: claim, mode: 'edit', })}
                                          />
                                    )
                                }
                                  
                                ) }
                            </TableBody>
                        </Table>
                    </div>
                    {item?.insurance_claims?.length === 0 ? <NoRecordFound /> : null}
                </Grid>
            </Grid>
            {
                claimCRU?.modal ?
                    <ClaimCRU
                       fileUpload={handleUpload}
                        claimCRU={claimCRU}
                        extraData={item}
                        modeType={claimCRU?.mode}
                        getResponseBack={getResponseBack}
                        onOpenAttachments={() => setAttachments({ modal: true, data: claimCRU?.data, mode:'view' })}
                        onToggleModal={() => setClaimCRU({ modal: false, data: null, mode: '' })}
                    /> : null
            }
            {attachments.modal ?
                <ShowAttachments
                    moduleName="Claim"
                    url='delete-attachment'
                    permissionKey='insurance'
                    attachmentsData={attachments}
                    getResponseBack={onDeletAttachment}
                    toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
                    onViewDisabled={claimCRU?.mode === 'view' || attachments?.mode==='view'}
                /> : null
            }
            {deleteClaim.modal ?
                <DeletePopUp
                    modal={deleteClaim.modal}
                    title='Delete Claim'
                    onDeleteRecords={() => deleteClaimFn()}
                    content='Are you sure, you want to Delete?'
                    onToggleModal={() => setDeleteClaim({ modal: false, data: null })}
                /> : null
            }
            {
               revisionHistory.modal &&  
              <RevisionHistory 
               moduleName={"insurance_claim"}
               revisionHistory={revisionHistory}
               onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
             />
            }
             <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}

export default InsuranceList;
